import {
  createOverviewLink,
  getTableRowLinks,
} from "src/utils/internalLinksParsing";
import { Breadcrumb, Breadcrumbs, DetailBreadcrumb } from "./types";

const accOfBreadcrumbIds = (
  currentId: number,
  breadcrumbs: Breadcrumbs,
  ids: number[]
): number[] => {
  const { childId } = breadcrumbs[currentId];

  if (childId === null) return ids;

  return accOfBreadcrumbIds(childId, breadcrumbs, [...ids, childId]);
};

export const getBreadcrumbsIdsToRemove = (
  rootId: number,
  breadcrumbs: Breadcrumbs
) => {
  const { childId } = breadcrumbs[rootId];

  return accOfBreadcrumbIds(rootId, breadcrumbs, []);
};

export const createBreadcrumbOverviewLink = (breadcrumb: Breadcrumb) =>
  createOverviewLink({
    id: breadcrumb.id,
  });

export const createBreadcrumbDetailLink = (breadcrumb: DetailBreadcrumb) => {
  const { rowKey, id, overviewId, defaultSOR, type } = breadcrumb;

  const { editLink, detailLink } = getTableRowLinks(
    {
      rowKeyValue: rowKey,
      templateId: id,
      overviewId,
      templateType: "detail",
    },
    { sor: defaultSOR }
  );

  return type === "detail" ? detailLink : editLink;
};
